import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { newsData } from '../components/News';
import { Calendar, Tag, ArrowLeft, Info, AlertTriangle, CheckCircle, Share2, Facebook, Twitter, Link as LinkIcon } from 'lucide-react';
export function NewsPostPage() {
  const {
    id
  } = useParams();
  // Find the post by ID, or fallback to the first post for demo purposes
  const post = newsData.find(item => item.id === Number(id)) || newsData[0];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  return <div className="min-h-screen bg-gray-50" data-id="element-867">
      <Header data-id="element-868" />

      <main className="pt-28 pb-20" data-id="element-869">
        <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-870">
          {/* Breadcrumb */}
          <Link to="/news" className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-primary transition-colors mb-8 group" data-id="element-871">
            <ArrowLeft className="mr-2 h-4 w-4 group-hover:-translate-x-1 transition-transform" data-id="element-872" />
            До всіх новин
          </Link>

          {/* Article Header */}
          <header className="mb-10" data-id="element-873">
            <div className="flex items-center gap-4 mb-5" data-id="element-874">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-semibold" data-id="element-875">
                <Tag className="mr-1.5 h-4 w-4" data-id="element-876" />
                {post.category}
              </span>
              <span className="inline-flex items-center text-gray-500 text-sm font-medium" data-id="element-877">
                <Calendar className="mr-1.5 h-4 w-4" data-id="element-878" />
                {post.date}
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary leading-tight mb-6" data-id="element-879">
              {post.title}
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed font-medium" data-id="element-880">
              {post.excerpt}
            </p>
          </header>

          {/* Hero Image */}
          <figure className="mb-12" data-id="element-881">
            <img src={post.image} alt={post.title} className="w-full h-auto rounded-2xl shadow-md object-cover aspect-[16/9]" data-id="element-882" />
            <figcaption className="text-center text-sm text-gray-500 mt-3" data-id="element-883">
              Фото: Офіційний архів ФАіСУ / Ілюстративне зображення
            </figcaption>
          </figure>

          {/* Rich Text Content Wrapper */}
          <div className="
            text-gray-700 text-lg leading-relaxed
            [&>h2]:text-2xl [&>h2]:md:text-3xl [&>h2]:font-heading [&>h2]:font-bold [&>h2]:text-primary [&>h2]:mt-12 [&>h2]:mb-6
            [&>h3]:text-xl [&>h3]:md:text-2xl [&>h3]:font-heading [&>h3]:font-bold [&>h3]:text-primary [&>h3]:mt-10 [&>h3]:mb-4
            [&>h4]:text-lg [&>h4]:md:text-xl [&>h4]:font-heading [&>h4]:font-bold [&>h4]:text-primary [&>h4]:mt-8 [&>h4]:mb-4
            [&>p]:mb-6
            [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:mb-6 [&>ul>li]:mb-2 [&>ul>li]:pl-2
            [&>ol]:list-decimal [&>ol]:pl-6 [&>ol]:mb-6 [&>ol>li]:mb-2 [&>ol>li]:pl-2
            [&_a]:text-blue-600 [&_a]:underline [&_a]:underline-offset-4 [&_a]:hover:text-blue-800 [&_a]:transition-colors
            [&_strong]:font-bold [&_strong]:text-gray-900
            [&>blockquote]:border-l-4 [&>blockquote]:border-primary [&>blockquote]:bg-white [&>blockquote]:shadow-sm [&>blockquote]:p-6 [&>blockquote]:italic [&>blockquote]:my-8 [&>blockquote]:rounded-r-xl
            [&>figure]:my-10
            [&>figure>img]:rounded-xl [&>figure>img]:shadow-md [&>figure>img]:w-full
            [&>figure>figcaption]:text-center [&>figure>figcaption]:text-sm [&>figure>figcaption]:text-gray-500 [&>figure>figcaption]:mt-3
            [&>table]:w-full [&>table]:text-left [&>table]:border-collapse [&>table]:my-8 [&>table]:bg-white [&>table]:shadow-sm [&>table]:rounded-lg [&>table]:overflow-hidden
            [&>table_th]:bg-gray-50 [&>table_th]:border-b-2 [&>table_th]:border-gray-200 [&>table_th]:p-4 [&>table_th]:font-semibold [&>table_th]:text-primary
            [&>table_td]:border-b [&>table_td]:border-gray-100 [&>table_td]:p-4 [&>table_td]:align-top
            [&>hr]:my-12 [&>hr]:border-gray-200
          " data-id="element-884">
            {/* DEMO CONTENT START */}
            <p data-id="element-885">
              Цей текст є демонстрацією стилів для типових HTML елементів, які
              можуть зустрічатися у новинах. Як зазначає керівництво,{' '}
              <strong data-id="element-886">розвиток спорту</strong> є пріоритетним напрямком нашої
              діяльності у поточному році. Детальну інформацію можна знайти на{' '}
              <a href="#" data-id="element-887">офіційному сайті міжнародної федерації</a>.
            </p>

            <h2 data-id="element-888">Офіційні результати змагань</h2>
            <p data-id="element-889">
              Після напруженої боротьби у фіналі, суддівська колегія затвердила
              остаточні результати. Спортсмени продемонстрували надзвичайну
              витривалість та техніку на оновлених маршрутах.
            </p>

            <table data-id="element-890">
              <thead data-id="element-891">
                <tr data-id="element-892">
                  <th data-id="element-893">Місце</th>
                  <th data-id="element-894">Спортсмен</th>
                  <th data-id="element-895">Регіон</th>
                  <th data-id="element-896">Результат</th>
                </tr>
              </thead>
              <tbody data-id="element-897">
                <tr data-id="element-898">
                  <td data-id="element-899">🥇 1</td>
                  <td data-id="element-900">Олександр Коваленко</td>
                  <td data-id="element-901">Київ</td>
                  <td data-id="element-902">Top (2:14)</td>
                </tr>
                <tr data-id="element-903">
                  <td data-id="element-904">🥈 2</td>
                  <td data-id="element-905">Михайло Петренко</td>
                  <td data-id="element-906">Харківська обл.</td>
                  <td data-id="element-907">Top (2:45)</td>
                </tr>
                <tr data-id="element-908">
                  <td data-id="element-909">🥉 3</td>
                  <td data-id="element-910">Ігор Сидоренко</td>
                  <td data-id="element-911">Дніпропетровська обл.</td>
                  <td data-id="element-912">Zone 4</td>
                </tr>
              </tbody>
            </table>

            {/* Success Alert */}
            <div className="flex items-start gap-4 p-5 rounded-xl bg-green-50 text-green-900 my-8 border border-green-100 shadow-sm" data-id="element-913">
              <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-914" />
              <div data-id="element-915">
                <h4 className="font-bold mb-1 text-green-900 !mt-0" data-id="element-916">
                  Новий національний рекорд
                </h4>
                <p className="text-green-800 text-base m-0" data-id="element-917">
                  Під час кваліфікації було встановлено новий рекорд траси, який
                  перевершив попередній результат на 1.5 секунди.
                </p>
              </div>
            </div>

            <h3 data-id="element-918">Коментар головного судді</h3>
            <blockquote data-id="element-919">
              "Цього року ми побачили безпрецедентний рівень підготовки
              учасників. Траси були складнішими ніж зазвичай, але більшість
              фіналістів впоралися з ними блискуче. Це свідчить про правильний
              вектор розвитку нашого спорту."
              <footer className="mt-3 text-sm text-gray-500 font-semibold not-italic" data-id="element-920">
                — Головний суддя змагань
              </footer>
            </blockquote>

            <h3 data-id="element-921">Основні нововведення сезону</h3>
            <p data-id="element-922">
              Звертаємо увагу тренерів та спортсменів на зміни у регламенті, які
              набувають чинності з наступного місяця:
            </p>
            <ul data-id="element-923">
              <li data-id="element-924">
                Обов'язкова попередня онлайн-реєстрація за 14 днів до старту.
              </li>
              <li data-id="element-925">
                Оновлені вимоги до сертифікації страхувального спорядження.
              </li>
              <li data-id="element-926">
                Зміни у системі нарахування рейтингових балів для юнацьких
                категорій.
              </li>
              <li data-id="element-927">
                Впровадження електронної системи фіксації часу на всіх етапах.
              </li>
            </ul>

            <figure data-id="element-928">
              <img src="https://images.unsplash.com/photo-1522163182402-834f871fd851?w=800&q=80" alt="Спортсмен на трасі" data-id="element-929" />
              <figcaption data-id="element-930">
                Момент проходження фінальної траси у категорії "Трудність"
              </figcaption>
            </figure>

            {/* Warning Alert */}
            <div className="flex items-start gap-4 p-5 rounded-xl bg-amber-50 text-amber-900 my-8 border border-amber-100 shadow-sm" data-id="element-931">
              <AlertTriangle className="h-6 w-6 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-932" />
              <div data-id="element-933">
                <h4 className="font-bold mb-1 text-amber-900 !mt-0" data-id="element-934">
                  Важливе нагадування щодо безпеки
                </h4>
                <p className="text-amber-800 text-base m-0" data-id="element-935">
                  Використання несертифікованого спорядження призводить до
                  негайної дискваліфікації учасника без права апеляції.
                </p>
              </div>
            </div>

            <h4 data-id="element-936">Подальші плани</h4>
            <ol data-id="element-937">
              <li data-id="element-938">Формування національної збірної за результатами етапів.</li>
              <li data-id="element-939">Проведення навчально-тренувальних зборів у Карпатах.</li>
              <li data-id="element-940">Участь у міжнародних стартах серії Кубка Європи.</li>
            </ol>

            <hr data-id="element-941" />

            {/* Info Alert */}
            <div className="flex items-start gap-4 p-5 rounded-xl bg-blue-50 text-blue-900 my-8 border border-blue-100 shadow-sm" data-id="element-942">
              <Info className="h-6 w-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-943" />
              <div data-id="element-944">
                <h4 className="font-bold mb-1 text-blue-900 !mt-0" data-id="element-945">
                  Додаткова інформація
                </h4>
                <p className="text-blue-800 text-base m-0" data-id="element-946">
                  Повні протоколи змагань та фотозвіт будуть опубліковані у
                  розділі "Документи" протягом трьох робочих днів.
                </p>
              </div>
            </div>
            {/* DEMO CONTENT END */}
          </div>

          {/* Share & Tags Section */}
          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-947">
            <div className="flex items-center gap-3" data-id="element-948">
              <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider" data-id="element-949">
                Теги:
              </span>
              <div className="flex gap-2" data-id="element-950">
                <span className="px-3 py-1 bg-gray-100 text-gray-600 text-sm rounded-full hover:bg-gray-200 cursor-pointer transition-colors" data-id="element-951">
                  {post.category}
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-600 text-sm rounded-full hover:bg-gray-200 cursor-pointer transition-colors" data-id="element-952">
                  ФАіСУ
                </span>
              </div>
            </div>

            <div className="flex items-center gap-4" data-id="element-953">
              <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider" data-id="element-954">
                Поділитися:
              </span>
              <div className="flex gap-2" data-id="element-955">
                <button className="p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-blue-600 hover:text-white transition-colors" aria-label="Share on Facebook" data-id="element-956">
                  <Facebook className="h-4 w-4" data-id="element-957" />
                </button>
                <button className="p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-sky-500 hover:text-white transition-colors" aria-label="Share on Twitter" data-id="element-958">
                  <Twitter className="h-4 w-4" data-id="element-959" />
                </button>
                <button className="p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-800 hover:text-white transition-colors" aria-label="Copy link" data-id="element-960">
                  <LinkIcon className="h-4 w-4" data-id="element-961" />
                </button>
              </div>
            </div>
          </div>
        </article>
      </main>

      <Footer data-id="element-962" />
    </div>;
}